import { apiClient, type Paginated } from '@/core/api';
import type {
  MCPActivityDto,
  MCPActivityListParams,
  SchoolAPIKeyCreateInput,
  SchoolAPIKeyCreatedDto,
  SchoolAPIKeyDto,
  SchoolAPIKeyListParams,
} from './types';

/** `GET /api/school-api-keys/` — admins see every key of the school, teachers
 *  only their own. The scoping is the server's; the client never filters. */
export async function getApiKeys(
  params: SchoolAPIKeyListParams = {}
): Promise<Paginated<SchoolAPIKeyDto>> {
  const { data } = await apiClient.get<Paginated<SchoolAPIKeyDto>>('/school-api-keys/', {
    params,
  });
  return data;
}

/**
 * `POST /api/school-api-keys/` — mints a key and returns the plaintext ONCE.
 *
 * The caller must show it immediately and never store it: it is hashed on the
 * row, so a lost key can only be replaced, never recovered.
 */
export async function createApiKey(
  input: SchoolAPIKeyCreateInput
): Promise<SchoolAPIKeyCreatedDto> {
  const { data } = await apiClient.post<SchoolAPIKeyCreatedDto>('/school-api-keys/', input);
  return data;
}

/** `DELETE /api/school-api-keys/{prefix}/` — revokes. The row stays (its
 *  activity keeps an owner) and the key fails closed immediately. */
export async function revokeApiKey(prefix: string): Promise<void> {
  await apiClient.delete(`/school-api-keys/${prefix}/`);
}

/** `GET /api/mcp-activity/` — admins see the whole school, teachers their own. */
export async function getMcpActivity(
  params: MCPActivityListParams = {}
): Promise<Paginated<MCPActivityDto>> {
  const { data } = await apiClient.get<Paginated<MCPActivityDto>>('/mcp-activity/', { params });
  return data;
}
